import { SOGetAssessment } from '../assessment/so-get-assessment';
import { SOGetBlock } from '../block/so-get-block';
import { SOGetProcess } from '../process/so-get-process';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENSeverity} from '../../enums';


export class SOPostDeficiency {

  constructor(
    public name: string,
    public active: boolean,
    public severity: ENSeverity,
    public project: SOGetProject,
    public organization: SOGetOrganization,
    public description: string = "",
    public assessment: SOGetAssessment = null,
    public block: SOGetBlock = null,
    public process: SOGetProcess = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostDeficiency(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'active' in params ? params.active : null,
      'severity' in params ? params.severity : null,
      'assessment' in params ? params.assessment : null,
      'block' in params ? params.block : null,
      'process' in params ? params.process : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
